/* unplugin-vue-components disabled */import { render } from "./LastHourFeed.vue?vue&type=template&id=d1c0fdce&scoped=true&ts=true"
import script from "./LastHourFeed.vue?vue&type=script&lang=ts"
export * from "./LastHourFeed.vue?vue&type=script&lang=ts"

import "./LastHourFeed.vue?vue&type=style&index=0&id=d1c0fdce&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c0fdce"]])

export default __exports__